import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-scheme-modal',
  templateUrl: './scheme-modal.component.html'
})
export class SchemeModalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
